import React from 'react';
import Spinner from '@teetsh/app/src/components/Buttons/Spinner';
import { BaseButtonProps } from './BaseButtonProps';
import tw from 'twin.macro';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { IconSize } from '@teetsh/app/src/components/Icons/icon';

interface IconProps {
  hasChildren: boolean;
  iconSize?: IconSize;
}

const getIconSize = (size: IconSize) => [
  size === 'sm' && tw`h-4 w-4`,
  size === 'md' && tw`h-5 w-5`,
  size === 'xs' && tw`h-3 w-3`,
  size === 'lg' && tw`h-6 w-6`,
  size === 'xl' && tw`h-7 w-7`,
];
const StyledIcon = styled('div', {
  shouldForwardProp: prop => isPropValid(prop),
})(
  (
    p: IconProps & {
      invisible?: boolean;
      iconSize?: IconSize;
      position: 'left' | 'right';
    },
  ) => [
    tw`shrink-0`,
    p.hasChildren &&
      p.iconSize != 'sm' &&
      p.position === 'left' &&
      tw`-ml-1 mr-2`,
    p.hasChildren &&
      p.iconSize === 'sm' &&
      p.position === 'left' &&
      tw`-ml-1 mr-1.5`,
    p.hasChildren && p.position === 'right' && tw`-mr-1 ml-2`,
    p.invisible && tw`invisible`,
    p.iconSize && getIconSize(p.iconSize),
  ],
);

export function ButtonContent(props: BaseButtonProps) {
  const { loading, intent = 'none' } = props;
  const iconSize =
    props.iconSize ||
    (() => {
      if (props.large || props.extralarge) {
        return !props.children ? 'lg' : 'md';
      }
      return !props.children ? 'md' : 'sm';
    })();
  if (loading) {
    return (
      <>
        <Spinner
          size={props.large ? 'md' : 'xs'}
          css={[
            tw`absolute m-0 items-center flex justify-center overflow-visible align-middle`,
            intent === 'none' && tw`text-neutral-quiet`,
          ]}
        />
        {props.icon && (
          <StyledIcon
            hasChildren={!!props.children}
            as={props.icon as any}
            iconSize={iconSize}
            style={props.iconStyle}
            position="left"
            invisible
          />
        )}
        <span tw="invisible">{props.children}</span>
        {props.rightIcon && (
          <StyledIcon
            hasChildren={!!props.children}
            as={props.rightIcon as any}
            iconSize={iconSize}
            style={props.rightIconStyle}
            position="right"
            invisible
          />
        )}
      </>
    );
  }
  return (
    <>
      {props.icon && (
        <StyledIcon
          hasChildren={!!props.children}
          as={props.icon as any}
          position="left"
          style={props.iconStyle}
          iconSize={iconSize}
        />
      )}
      {props.children}
      {props.rightIcon && (
        <StyledIcon
          hasChildren={!!props.children}
          as={props.rightIcon as any}
          style={props.rightIconStyle}
          position="right"
          iconSize={iconSize}
        />
      )}
    </>
  );
}
